var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5817 5.18592L9.4801 4.08435L2.2241 11.3404V12.4419H3.32567L10.5817 5.18592ZM11.6832 4.08435L12.7848 2.98279L11.6832 1.88122L10.5817 2.98279L11.6832 4.08435ZM3.97071 14H0.666016V10.6945L11.1324 0.228093C11.2785 0.0820452 11.4767 0 11.6832 0C11.8898 0 12.0879 0.0820452 12.234 0.228093L14.4379 2.432C14.584 2.5781 14.666 2.77621 14.666 2.98279C14.666 3.18936 14.584 3.38748 14.4379 3.53357L3.97149 14H3.97071Z",
    fill: "#63658E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9a4aadc5d34343e2dc864417aebaf120.svg";
export { ForwardRef as ReactComponent };